import { ThemeNames } from 'constantsValues/themeNames';
import { useThemeName } from 'hooks/useThemeName';
import styles from './PolicyPreviewButton.module.scss';
import arrowIcon from './resources/arrow_icon.svg';
import arrowRightIcon from './resources/arrow_right.svg';

export const PolicyPreviewButton = ({ policyNumber }: { policyNumber: string }) => {
	const themeName = useThemeName();
	const isAlmbrand = themeName === ThemeNames.almbrand;

	return (
		<button className={styles.PolicyPreviewButton__button}>
			{policyNumber}
			<img
				className={styles.PolicyPreviewButton__icon}
				src={isAlmbrand ? arrowRightIcon : arrowIcon}
				alt='Arrow Icon'
			/>
		</button>
	);
};
